<template>

    <LinkHover
        :type="'router-link'"
        :to="$trl({
            name: 'Article',
            params: {
                slug: post.customslug || post.slug,
                locale: $route.params.locale
            }
        })"
        class="post"
    >
        <div class="default content">
            <IconArrow/>
            <span class="caption">
                {{ post.name }}
            </span>
        </div>
        <template v-slot:hover>
            <div class="hover content">
                <IconArrow/>
                <span class="caption">
                    {{ post.name }}
                </span>
            </div>
        </template>
    </LinkHover>
</template>
<script>
import LinkHover from '@/components/animation/LinkHover'
import IconArrow from '@/components/IconArrow'
export default {
    components: {
        LinkHover,
        IconArrow
    },
    props: {
        post: {
            type: Object,
            default() {}
        }
    },
    computed: {
        related() {
            const res = (this.$parent.$parent.page.type === 'project') ?
                this.$parent.$parent.page.related_posts
                    .filter(item => {
                        return this.post.related_posts.find(_ => _ === item.id)
                    }) : [{ name: this.$parent.$parent.page.name }]
            return res
        },
        country() {
            return this.post.related_posts.find(_ => _.type === 'country')
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.post
    flex: 1
    box-sizing: border-box
    display: flex
    text-decoration: none
    min-height: 80px
    &+.post
        border-top: 1px solid #e0e1e3
.content
    display: flex
    height: 80px
    align-items: center
    width: 100%
.hover
    background-color: #ff2b2a
    .caption
        color: #ffffff

    svg
        /deep/ path
            fill: #ffffff

svg
    margin-left: 60px
    margin-right: 32px


.caption
    font-size: 17px
    color: #636772
    font-weight: 500
    line-height: 1.2
    min-height: 2.4em
    flex: 1
    display: flex
    flex-direction: column
    justify-content: center
    margin-right: 60px
</style>
